import { useEffect, useState } from 'react';
const getWindowSize = () => ({
    width: window.innerWidth,
    height: window.innerHeight,
});
export default function useWindowSize() {
    const [size, setSize] = useState(getWindowSize());
    useEffect(() => {
        const updateSize = () => setSize(getWindowSize());
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, [setSize]);
    return size;
}
